module.exports = __webpack_public_path__ + "water.svg?2d48c8e6765a3afb8d2c0e6aaad57faf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/badges/water.svg
// module id = 94
// module chunks = 0